import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { Typography } from '../../../typography/components/Typography/Typography';

interface Props {
   align?: 'left' | 'center' | 'right';
   children: ReactNode;
   colSpan?: number;
   onClick?: () => void;
   rowSpan?: number;
   verticalAlign?: 'top' | 'middle' | 'baseline' | 'bottom';
   width?: string;
   whiteSpace?: 'normal' | 'nowrap';
   wordBreak?: 'normal' | 'all' | 'keep' | 'words';
   paddingX?: 'sm' | 'md' | 'lg';
   sticky?: boolean;
   stickyOffset?: string;
}

const paddingMap = {
   sm: 'px-component-layout-box-spacing-padding-edge-to-text-horizontal-sm',
   md: 'px-component-layout-box-spacing-padding-edge-to-text-horizontal-md',
   lg: 'px-component-layout-box-spacing-padding-edge-to-text-horizontal-lg'
};

export const TableCell: FC<Props> = ({ align = 'left', colSpan = 1, rowSpan = 1, verticalAlign = 'middle', width, children, onClick, whiteSpace = 'normal', wordBreak = 'normal', paddingX = 'lg', sticky = false, stickyOffset = '0' }) => (
   <td
      data-testid="table-cell"
      align={align}
      colSpan={colSpan}
      rowSpan={rowSpan}
      valign={verticalAlign}
      onClick={onClick}
      className={classNames(paddingMap[paddingX], 'py-component-layout-box-spacing-padding-edge-to-element-vertical-lg snap-start', {
         'whitespace-nowrap': whiteSpace === 'nowrap',
         'whitespace-normal': whiteSpace === 'normal',
         'break-all': wordBreak === 'all',
         'break-normal': wordBreak === 'normal',
         'break-keep': wordBreak === 'keep',
         'break-words': wordBreak === 'words'
      })}
      style={{ minWidth: width, maxWidth: width, ...(sticky && { position: 'sticky', left: stickyOffset, zIndex: 1, background: 'var(--component-data-display-table-cell-color-background-regular-default)' }) }}
   >
      <Typography variant="body" color="strong">
         {children}
      </Typography>
   </td>
);
